<template>
    <div class="container">
        <div style="margin: 45px 0 20px;  color: rgb(30, 139, 195);font-weight: 500;font-size: 32px;">
            <span>История проверок</span>
        </div>
        <adminFilters v-if="admin" adminType="check_fl" :onFilterCallback="getHistory" @admin-request="adminRequest" :searchPlaceholder="'Населенный пункт, улица'" @history-refresh="historyRefresh" />
        <pagination v-if="pagination && isHistory" :pagination="pagination" :onTurnPageCallBack="getHistory" :showRowsPerPageSelection="false" :rows_on_page="history.length"/>
        <table class="history__table" v-if="isHistory">
            <thead>
                <tr>
                    <th>Дата и время проверки</th>
                    <th v-if="admin">Пользователь</th>
                    <th>Объект проверки</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(e,i) in history" :key="i">
                    <td>{{e.date ? e.date : ''}}</td>
                    <td v-if="admin"> {{e.user_name}}<br>
                        {{e.user_login ? `(${e.user_login})` : ''}}</td>
                    <td>
                        <span v-if="e.response.code === 0 && e.response && e.response.data">
                            <i v-if="e.response.data.status === 1" class='uk-icon-check' style='cursor: help' title='Данные найдены'></i>
                            <i v-else-if="e.response.data.status < 0" class='uk-icon-close' style='cursor: help' title='Ошибка'></i>
                            <i v-else-if="e.response.data.status === 2" class='uk-icon-minus-circle' style='cursor: help' title='Данные не найдены'></i>
                        </span>
                        <span v-else>
                            <i class='uk-icon-close' style='cursor: help' title='Ошибка'></i>
                        </span>
                        <span v-if="e.response && e.response.code === 0 && e.response.data && e.response.data.status === 1" @click="getAddressFromHistory(e.response.data, e.request_params, e.date)" class="uk-pseudolink">
                            {{ e.request_params | getAddress }}
                        </span>
                        <span v-else>
                            {{ e.request_params | getAddress }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <pagination v-if="pagination && isHistory" :pagination="pagination" :onTurnPageCallBack="getHistory" :showRowsPerPageSelection="false" :rows_on_page="history.length"/>
    </div>
</template>

<script>
import axios from 'axios'
import pagination from '@/components/ui/pagination.vue'
import adminFilters from '@/components/ui/adminFilters.vue'

export default {
    components: {
        pagination,
        adminFilters
    },
    data() {
        return {
            show_adm: true,
            searchQuery: '',
            users: [],
            date_from: '',
            date_to: ''
        }
    },
    mounted() {
        this.getHistory()
    },
    computed: {
        admin() { return this.$store.state.user?.groups?.filter(e => e.rules.adm_check_fl)?.length },
        pagination() { return this.$store.state?.addressCheck?.history?.pagination },
        history() { return this.$store.state?.addressCheck?.history?.list },
        isHistory() { return this.history?.length > 0 }
    },
    methods: {
        adminRequest(value){
            this.show_adm = value
            this.$store.commit('addressCheck/setShowAdm', value)
        },
        getAddressFromHistory(response, request_params, date) {
           this.$store.commit('addressCheck/setData', { ...response, request_params, date })
           this.$store.commit('addressCheck/toggleModal', true)
        },
        getHistory(
            offset = 0,
            limit = 50,
            search = this.searchQuery,
            filterUsers = this.users.length ? this.users : [],
            dateFrom = this.date_from,
            dateTo = this.date_to,
            show_adm = this.show_adm
            
        ) {
            const reqObj = {
                dateFrom,
                dateTo,
                search,
                filterUsers,
                show_adm,
                offset,
                limit
            }
            this.$store.dispatch('addressCheck/getHistory', reqObj)
        },
        historyRefresh() {
            this.history.searchQuery = ''
            this.history.users = ''
            this.history.date_from = ''
            this.history.date_to = ''
            this.getHistory()
        }
    },
    filters: {
        getAddress(request_params) {
            const { city, street, house, build, flat } = request_params
            return `${city ? `г. ${city}` : ''}${street ? `, ул. ${street}` : ''}${house ? `, д. ${house}` : ''}${build ? `, к. ${build}` : ''}${flat ? `, кв/оф ${flat}` : ''}`
        }
    }

}
</script>

<style lang="sass" scoped>
@import "styles/global-variables.sass"

.history
    &__header
        margin-top: 25px
        font-size: 24px
        font-weight: 600
    &__table
        width: 100%
        text-align: left
        font-size: 14px
        th
            font-weight: 600
            padding: 10px 0
        td
            padding: 5px 0
.uk-icon-
    &check
        color: green
    &close
        color: red
    &minus-circle
        color: orange            
</style>